<template>
  <div class="usc-data gutter-lg mb body">
    <div class="usc-data__col usc-data__col--left">
      <slot name="title"></slot>
      <div class="usc-data__key" v-for="(item, index) in data">
        <div class="usc-data__key-block" :style="{ backgroundColor: item.color }"></div>
        <div class="usc-data__key-label">
          <div class="usc-data__label-bold">
            {{item.labelBold}}
          </div>
          <div class="usc-data__label-small">
            {{item.labelSmall}}
          </div>
        </div>
      </div>
    </div>
    <div class="usc-data__col usc-data__col--svg">
      <div v-if="hasSVG" class="scaling-svg-container">
        <slot name="svg"></slot>
      </div>
      <slot name="label"></slot>
    </div>

  </div>
</template>

<script>
export default {
  name: 'DataViz',
  props: ['data'],
  data () {
    return {

    }
  },
  computed: {
    hasSVG () {
      return this.$slots.svg
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '~styles/vars';
  .scaling-svg-container {
   position: relative;
   height: 0;
   width: 100%;
   padding: 0;
   padding-bottom: 100%;
   /* override this inline for aspect ratio other than square */
}
.scaling-svg {
   position: absolute;
   height: 100%;
   width: 100%;
   left: 0;
   top: 0;
}
.usc-data {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  h3 {
    max-width: 450px;
    margin-bottom: 22px;
  }
  &__col {
    width: 100%;
    position: relative;
    // @media (min-width: $screen-sm-min) {
    @media (min-width: 1040px) {
      width: 45%;
    }
    &--left {
      order: 2;
      // @media (min-width: $screen-sm-min) {
      @media (min-width: 1040px) {
        order: 2;
      }
    }
    &--svg {
      order: 1;
      margin-bottom: 25px;
      max-width: 430px;
      // @media (min-width: $screen-sm-min) {
      @media (min-width: 1040px) {
        order: 1;
        margin-bottom: 0;
      }
    }
  }
  &__key {
    display: flex;
    flex-flow: row nowrap;
    // align-items: center;
    margin-bottom: 20px;
    @media (min-width: $screen-md-min) {
      max-width: 450px;
    }
  }
  &__key-block {
    width: 20px;
    height: 20px;
    margin-right: 20px;
    margin-top: 5px;
  }
  &__label-bold {
    font-family : $fNational;
    // font-family: 'Open Sans', sans-serif;
    font-weight : $fBold;
    // font-size : 17px;
    font-size: 1.7rem;
    color: #900;
    line-height : 24px;
    letter-spacing : 1.36px;
    text-transform : uppercase;
    @media (max-width: 1200px) {
      font-size: 1.5rem;
    }
    @media (max-width: 1038px) {
      font-size: 1.7rem;
    }
  }
  &__label-small {
    font-family : $fNational;
    // font-family: 'Open Sans', sans-serif;
    // font-style : italic;
    // font-size : 15px;
    font-size: 1.4rem;
    font-weight: 700;
    line-height : 24px;
    color: #464646;
    margin-top: .5em;
        @media (max-width: 1200px) {
      font-size: 1.3rem;
    }
    @media (max-width: 1038px) {
      font-size: 1.5rem;
    }
  }
  &__label-container {
    text-align: center;
    width: 100%;
    max-width: 200px;
    position: absolute;;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
  &__label-number {
    font-family : $fNational;
    font-weight : $fBold;
    // font-size : 40px;
    line-height : 1;
    text-transform : uppercase;
    margin-bottom: 20px;
    // font-family: 'Open Sans', sans-serif;
    font-size: 4rem;
    // font-weight: 800;
    color:#900;
    @media (max-width: 1300px) {
      margin-top: -15%;
    }
    @media (max-width: 1200px) {
      margin-top: -40%;
    }
    @media (max-width: 1084px) {
      font-size: 2.5rem;
      margin-top: -57%;
    }
    @media (max-width: 1038px) {
      font-size: 4rem;
      margin-top: 0%;
    }

  }
  &__label-sub {
    font-family : $fNational;
    // font-size : 17px;
    line-height : 24px;
    font-size: 1.5rem;
    // font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    color: #464646;
    @media (max-width: 1200px) {
      font-size: 1rem;
    }
    @media (max-width: 1038px) {
      font-size: 1.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DataViz.vue